import { render, staticRenderFns } from "./partialFooter.vue?vue&type=template&id=d143de20&scoped=true"
import script from "./partialFooter.vue?vue&type=script&lang=js"
export * from "./partialFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d143de20",
  null
  
)

export default component.exports